import type { FilterValues } from './Filters.types'

export const DEFAULT_INITIAL_VALUES: FilterValues = {
  productTitle: '',
  categoryId: '',
  backboxGrade: '',
  currency: '',
  competitionLevel: '',
}

export const VALUE_ALL = 'ALL'
